import { INQUIRY_STATUS } from '@/types'
import { DefineComponent, SVGAttributes } from 'vue'

/**
 * Status icons loaded eagerly, as plain components.
 */
const statusIconModules = import.meta.glob<{
  default: DefineComponent<SVGAttributes>
}>('../assets/status/*.svg', { eager: true })

export function matchInquiryStatusToIconEager(inquiryStatus: INQUIRY_STATUS) {
  const normalized = inquiryStatus!.toLowerCase().replaceAll(' ', '_')

  const module =
    statusIconModules[`../assets/status/${normalized}.svg`] ??
    statusIconModules['../assets/status/unconfirmed.svg']

  return module.default
}
